import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.5 2h-5C5.673 2 5 2.673 5 3.5v6.778A1.979 1.979 0 004 10c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2V6h6v3.278A1.979 1.979 0 0011 9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2V3.5c0-.827-.673-1.5-1.5-1.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M34.5 6h-15C17.02 6 15 8.02 15 10.5v20.334c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V18h18v9.834c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V10.5C39 8.02 36.98 6 34.5 6z",
    clipRule: "evenodd"
  }))
};
export var MusicFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});